import {
    useEffect,
    useState,
    useRef,
    type FC
} from "react";
import type IDataTableSearchProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useDataTableContext
} from "../../context";
import {
    Search as SearchIcon
} from "lucide-react-native";
import TextInput from "../../../textInput";

const DataTableSearch: FC<IDataTableSearchProps> = ({
    customTheme: customThemeProp,
    accessibilityLabel,
    placeholder,
    style
}) => {
    const context = useDataTableContext({
        part: "Search"
    });

    const {
        shapeConfigs,
        durations,
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const [
        query,
        setQuery
    ] = useState<string | undefined>(undefined);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isFlexible: context?.layout === "cards",
        shapeConfigs
    });

    const handleGlobalFilterChangeRef = useRef(context?.handleGlobalFilterChange);

    handleGlobalFilterChangeRef.current = context?.handleGlobalFilterChange;

    useEffect(() => {
        if(query === undefined) {
            return;
        }

        const timer = setTimeout(() => {
            handleGlobalFilterChangeRef.current?.(query);
        }, durations.medium);

        return () => {
            clearTimeout(timer);
        };
    }, [
        durations.medium,
        query
    ]);

    if(!context) {
        return null;
    }

    const renderIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <SearchIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    return <TextInput
        accessibilityLabel={accessibilityLabel ?? localize("search")}
        customTheme={customThemeProp ?? context.customTheme}
        placeholder={placeholder ?? localize("search")}
        isDisabled={context.isPermissionDenied}
        customLocalize={context.customLocalize}
        initialValue={context.globalFilter}
        key={context.searchResetKey}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        onChangeText={setQuery}
        isClearEnabled={true}
        inputMode="search"
        icon={renderIcon}
        size="small"
    />;
};
export default DataTableSearch;
